import React from "react";

/**
 * Admin grid Request Type badge: Initial Request (indigo/primary),
 * Joined Request (blue), Request Pending (yellow). Single-sponsor rows pass
 * a null/undefined requestType and render "--" instead of a badge.
 * Also reused as the per-sponsor role badge in Additional Participating
 * Sponsors, since both surfaces share the exact same label vocabulary.
 */
const REQUEST_TYPE_BADGE_CLASS = {
  "Initial Request": "bg-indigo-100 text-indigo-800 ring-indigo-200",
  "Joined Request": "bg-blue-100 text-blue-800 ring-blue-200",
  "Request Pending": "bg-yellow-100 text-yellow-800 ring-yellow-200",
};

const RequestTypeBadge = ({ requestType }) => {
  if (!requestType) {
    return <span className="text-gray-400">--</span>;
  }

  const colorClass =
    REQUEST_TYPE_BADGE_CLASS[requestType] ||
    "bg-gray-100 text-gray-800 ring-gray-200";

  return (
    <span
      className={`inline-flex flex-shrink-0 items-center whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset ${colorClass}`}
    >
      {requestType}
    </span>
  );
};

export default RequestTypeBadge;
